import { api } from '@api'
import { CarrierAvailabilityPayload } from '@types'

const base = '/carrier-availability'

const getCarrierAvailability = async () => {
  const response = await api.get(base)
  return response.data
}

const getCarriersAvailabilitySummary = async (date: string) => {
  const response = await api.get(`${base}/data/summarized?date=${date}`)
  return response.data.data
}

const postCarrierAvailability = async (payload: CarrierAvailabilityPayload) => {
  const response = await api.post(base, payload)
  return response.data
}

export { getCarrierAvailability, postCarrierAvailability, getCarriersAvailabilitySummary }
